import RELoginComponent from "../../components/retirement/login/RELoginComponent";


export default function RELoginBloc() {

    
      return (  
        <div className="bloc-coadherent--connexion bloc-connexion shadow-bleu va-center">
            <div className="bloc-connexion--connectform bg-blanc p-lg">
                <h2 className="card-title bleu mb-lg">Se connecter à votre parcours d'adhésion</h2>
                <RELoginComponent/>
            </div>
        </div>
    )
}